import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth, SignInPrompt } from './components/Auth';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ChatPage } from './components/ChatPage';
import { DashboardPage } from './components/Dashboard';
import { ManagementPage } from './components/Management';

function App() {
  // Get authentication state
  const { isAuthenticated, isLoading: authLoading } = useAuth();

  // Show loading state while checking authentication
  if (authLoading) {
    return (
      <div
        className="min-h-screen bg-background flex items-center justify-center"
        role="status"
        aria-label="Loading application"
      >
        <div className="text-center">
          <div
            className="inline-block w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mb-4"
            aria-hidden="true"
          ></div>
          <p className="text-zinc-600 dark:text-zinc-400 text-lg">Loading...</p>
        </div>
      </div>
    );
  }

  // Show sign-in prompt if not authenticated
  if (!isAuthenticated) {
    return <SignInPrompt />;
  }

  // Main authenticated app with routing
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/" element={<ChatPage />} />
        <Route path="/chats/:chatId" element={<ChatPage />} />
        <Route
          path="/dashboard"
          element={<Navigate to="/dashboard/metrics" replace />}
        />
        <Route path="/dashboard/:tab" element={<DashboardPage />} />
        <Route
          path="/management"
          element={<Navigate to="/management/clients" replace />}
        />
        <Route path="/management/:tab" element={<ManagementPage />} />
        <Route
          path="/management/documents/:clientSlug"
          element={<ManagementPage />}
        />
      </Routes>
    </ErrorBoundary>
  );
}

export default App;
